import { useState, type FormEvent } from 'react';
import { api } from '../lib/api';
import { Modal } from '../ui/Modal';
import { useAuth } from './AuthProvider';

export function PasswordModal() {
  const { passwordRequired, closePassword, passwordChanged } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (next.length < 12) return setError('Use at least 12 characters for the new password.');
    if (next !== confirm) return setError('New passwords do not match.');
    try {
      await api('/api/auth/password', { method: 'POST', body: { currentPassword: current, nextPassword: next } });
      passwordChanged();
    } catch (failure) {
      setError(failure instanceof Error ? failure.message : 'Password could not be changed.');
    }
  }

  return (
    <Modal id="passwordModal" size="sm" labelledBy="passwordTitle" dismissable={!passwordRequired} onClose={closePassword}>
      <form onSubmit={submit}>
        <p className="eyebrow">Account security</p>
        <h2 id="passwordTitle">{passwordRequired ? 'Set a new password' : 'Change password'}</h2>
        {passwordRequired && <p className="form-help">Replace your temporary password before continuing.</p>}
        <label>Current password <input type="password" autoComplete="current-password" value={current} onChange={(event) => setCurrent(event.target.value)} autoFocus /></label>
        <label>New password <input type="password" autoComplete="new-password" value={next} onChange={(event) => setNext(event.target.value)} /></label>
        <label>Confirm new password <input type="password" autoComplete="new-password" value={confirm} onChange={(event) => setConfirm(event.target.value)} /></label>
        <p className="form-error" aria-live="polite">{error}</p>
        <div className="form-actions"><button className="btn btn-primary" type="submit">Update password</button></div>
      </form>
    </Modal>
  );
}
